
const digest = '9aff4d2576c87f88fdfa970a76a2c3af3cda208604d6176ced472a85b25c57d6';
const classes = {"text":"_text_1d6f2_1"};
const css = `._text_1d6f2_1 {
  padding: 10px 34px;
  font-size: 14px;
  font-weight: 500;
  border-top: 2px solid #ebedf3;
  border-right: 2px solid #ebedf3;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  